export const WELL_ARCHITECTED_PROGRAM_NAME = "Well-Architected Partner Program";
export const ISV_WORKLOAD_MIGRATION_PROGRAM_NAME =
  "ISV Workload Migration Program";
export const AWS_JUMPSTART_PROGRAM_NAME = "AWS Jumpstart Program";
export const FIELDS_REQUIRED_FOR_WELL_ARCHITECTED = ["arn", "awsAccountId"];
